export default __webpack_public_path__ + "static/media/sp_beach.6c6f73e4.mp4";